module.exports = __webpack_public_path__ + "static/media/kasai.8d0eea61.png";